export default __webpack_public_path__ + "static/media/gallery_04.639fe0a6.jpg";